var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if ($("#preloader").length > 0) {
  $(window).on("load", function () {
    $("#preloader")
      .delay(1000)
      .fadeOut(1000, function () {
        if ($(".preloader-overflow").length > 0) {
          $("body").removeClass("preloader-overflow");
        }
      });
  });
}
if ($(".media-slick-slider  .thumbnail-list").length > 0) {
  $(".thumbnail-list").not(".slick-initialized").slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 4,
    slidesToScroll: 1,
  });
}

$(window).scroll(function () {
  if ($(window).width() > "1024") {
    if ($(window).scrollTop() >= 500) {
      $(".sticky-bar").css("display", "flex");
    } else {
      $(".sticky-bar").css("display", "none");
    }
  }
});

$(window).scroll(function () {
  if ($(window).width() < "1024") {
    if ($(window).scrollTop() >= 900) {
      $(".sticky-bar").css("display", "flex");
    } else {
      $(".sticky-bar").css("display", "none");
    }
  }
});

$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });
});

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");
};
if ($(".pagination-method-loadmore_btn").length > 0) {
  var AjaxMethod = "click";
} else {
  var AjaxMethod = "scroll";
}
if ($(".collection #AjaxinatePagination").length > 0) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

InitCustomFunctions();
function InitCustomFunctions() {
  if ($(".toggleFilter").length > 0) {
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
      $("body").addClass("overflow-hidden");
      $("body").addClass("filter-clicked");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
      $("body").removeClass("overflow-hidden");
      $("body").removeClass("filter-clicked");
    });
  }

  //product page color variant to select thumbnail img change color_variants
  if ($(".show-grouped__variant").length > 0) {
    $('input:radio[name="Color"]').click(function () {
      const cvariant = $(this).val();
      $('input:radio[name="Color"]')
        .next(".swatch-element")
        .removeClass("clicked");
      $(this).next(".swatch-element").addClass("clicked");
      $(".slick-list").addClass("height_fix");
      $(".thumbnail-list__item").each(function () {
        const variant_val = $(this).find("img").attr("alt");
        if (cvariant == variant_val) {
          $(this).addClass("show");
          $(this).removeClass("hidden");
        } else {
          $(this).addClass("hidden");
          $(this).removeClass("show");
        }
      });
    });
  }

  //     Item swatch trigger start
  $(document).on("click", ".color-values a", function () {
    if ($(this).hasClass("active")) {
      $(".color-values a").removeClass("active");
    } else {
      $(".color-values a").removeClass("active");
      $(this).addClass("active");
    }
  });

  $(document).on("click", ".size-values a", function () {
    if ($(this).hasClass("active")) {
      $(".size-values a").removeClass("active");
      $(this)
        .parents(".products")
        .find(".variant-option-size .size-values")
        .removeClass("active");
    } else {
      $(".size-values a").removeClass("active");
      $(this).addClass("active");
      $(this)
        .parents(".products")
        .find(".variant-option-size .size-values")
        .removeClass("active");
    }
  });
  $("body").on("click", ".color-values-plus a", function (e) {
    $(this)
      .parents(".variant-option-color")
      .find(".show-on-click")
      .css("display", "flex");
    $(this).parents(".color-values-plus").css("display", "none");
    e.preventDefault();
  });

  $("body").on("click", ".swatch-element.color", function () {
    $(this).next("label").find("i");
  });
  $("body").on("click", ".swatch span", function () {
    var featuredMedia = $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));
    $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));

    if ($(this).parents(".swatch").hasClass("color")) {
      const variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);

      var swatch_item = $(this).data("variant-item");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .size-values")
        .removeClass("active");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .swatch")
        .each(function () {
          var swatch_size_vars = $(this).find("span").data("variant-title");
          swatch_size_vars = swatch_size_vars.split("/");
          swatch_size_vars = $.map(swatch_size_vars, $.trim);
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.toLowerCase();
          });
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.replace(/ /g, "-");
          });

          if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
            $(this).parent(".size-values").toggleClass("active");
          }
        });
    }

    if ($(this).parents(".swatch").hasClass("size")) {
      var variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);
    }
  });

  //     Item swatch trigger end

  $(".custom-product-grid li").click(function () {
    var classNames =
      "list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop";
    var getCols = $(this).data("cols");
    $(".custom-product-grid li").removeClass("active");
    $(this).addClass("active");
    $("ul#product-grid").removeClass(classNames).addClass(getCols);
  });
  if ($(".filter-buttons").length > 0) {
    const viewExists = document.querySelector(".grid-view-button");
    if (viewExists.classList.contains("layout-mode")) {
      const listViewButton = document.querySelector(".list-view-button");
      const gridViewButton = document.querySelector(".grid-view-button");
      const list = document.querySelector("ul.view-mode");
      const gridviewlist = document.querySelector(".custom-product-grid");

      listViewButton.onclick = function () {
        listViewButton.classList.add("active");
        gridViewButton.classList.remove("active");
        list.classList.remove("grid-view-filter");
        list.classList.add("list-view-filter");
        gridviewlist.classList.add("hidden");
      };

      gridViewButton.onclick = function () {
        listViewButton.classList.remove("active");
        gridViewButton.classList.add("active");
        list.classList.remove("list-view-filter");
        list.classList.add("grid-view-filter");
        gridviewlist.classList.remove("hidden");
      };
    }
  }
  if ($("#swiper-sidebar-carousel").length > 0) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }

  setTimeout(function () {
    $(".loading-image").removeClass("loading-image").addClass("loaded-image");
  }, 2000);
}

//FBT ul li select box

$("ul.custom-select").on("click", "li:not(.init)", function () {
  var selectedVal = $(this).data("option-value");
  // console.log(selectedVal);
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option")
    .attr("selected", false);
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option[value=" + selectedVal + "]")
    .attr("selected", "selected")
    .trigger("change");
});

$("ul.custom-select").on("click", ".init", function () {
  $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
});

$("ul.custom-select").on("click", "li:not(.init)", function () {
  $(this).parent().children("li:not(.init)").removeClass("selected");
  $(this).addClass("selected");
  $(this).parent().children(".init").html($(this).html());
  $(this).parent().children(".init").removeClass("li-unselected");
  $(this).parent().children("li:not(.init)").toggle();
  if ($("ul.custom-select li.init").hasClass("li-unselected")) {
    $("#add-frequently-bought").prop("disabled", true);
  } else {
    $("#add-frequently-bought").prop("disabled", false);
  }
});
loadedBg();
function loadedBg() {
  window.onload = function () {
    setTimeout(function () {
      $(".loading-image").removeClass("loading-image").addClass("loaded-image");
    }, 3000);
  };
}

jQuery(function () {
  jQuery().on("click", function () {
    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {
        this.currentTime = 0;
        this.pause();
      });
  });
});

if ($(".enquiry-modal").length > 0) {
  var EnquiryModal = document.querySelector(".enquiry-modal");
  var EnquiryTrigger = document.querySelector("#trigger-enquiry");
  var Enquiryclose = document.querySelector(".enquiry-modal .close-button");

  function toggleModal() {
    EnquiryModal.classList.toggle("show-enquiry");
    document.querySelector("body").classList.toggle("enquiry-overlay");
  }
  function windowOnClick(event) {
    if (event.target === EnquiryModal) {
      toggleModal();
    }
  }

  EnquiryTrigger.addEventListener("click", toggleModal);
  Enquiryclose.addEventListener("click", toggleModal);
  window.addEventListener("click", windowOnClick);
}

document
  .querySelector(".header-drawer__close")
  .addEventListener("click", closeDrawerMenu);
function closeDrawerMenu() {
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
}

$("#dT_TopStickySearchBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").addClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "1");
  $("body").addClass("search-overlay-open");
});

$(".dT_TopStickySearchCloseBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").removeClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "0");
  $("body").removeClass("search-overlay-open");
});

setTimeout(function () {
  $("#AccessibleNav .sub-menu-block").show();
}, 1000);

document.addEventListener("DOMContentLoaded", function () {

  /* ✅ Only run on the wheel page */
  const container = document.getElementById("spin-wheel-container");
  if (!container) return;

  /* ----------------------------
     HTML Markup
  ----------------------------- */
  container.innerHTML = `
    <div style="text-align:center; font-family:Arial; padding:30px;">
      <h2 style="font-size:42px; font-weight:800; margin-bottom:10px;">
        Spin the Wheel 🎡
      </h2>

      <p style="font-size:18px; margin-bottom:25px;">
        Enter your email to spin &amp; win a free prize!
      </p>

      <!-- Email Gate -->
      <div id="emailGate" style="margin-bottom:20px;">
        <input id="emailInput" type="email" placeholder="you@example.com"
          style="
            padding:12px 16px;
            font-size:16px;
            border:2px solid #ccc;
            border-radius:10px;
            width:260px;
            max-width:80%;
            outline:none;
          ">
        <br><br>
        <button id="subscribeBtn"
          style="
            padding:14px 32px;
            font-size:18px;
            font-weight:700;
            border:none;
            border-radius:10px;
            background:black;
            color:white;
            cursor:pointer;">
          SUBSCRIBE &amp; SPIN
        </button>
        <p id="emailError"
          style="margin-top:8px; font-size:14px; color:#c62828; display:none;">
        </p>
      </div>

      <div style="
        position:relative;
        display:flex;
        justify-content:center;
        align-items:center;
        margin:0 auto;
      ">
        <!-- Canvas -->
        <canvas id="wheelCanvas"></canvas>

        <!-- Pointer -->
        <div style="
          position:absolute;
          top:-8px;
          left:50%;
          transform:translateX(-50%);
          width:0;
          height:0;
          border-left:16px solid transparent;
          border-right:16px solid transparent;
          border-top:28px solid black;">
        </div>
      </div>

      <br><br>

      <button id="spinBtn"
        style="
          display:none;
          padding:14px 32px;
          font-size:18px;
          font-weight:700;
          border:none;
          border-radius:10px;
          background:black;
          color:white;
          cursor:pointer;">
        SPIN
      </button>
      <p style="
        margin-top:12px;
        font-size:13px;
        color:#555;
        max-width:320px;
        margin-left:auto;
        margin-right:auto;
        line-height:1.4;
      ">
        *Physical prizes will be shipped with your next order.
      </p>

      <h3 id="result"
        style="margin-top:30px; font-size:22px;">
      </h3>

      <button id="addToCartBtn"
        style="
          display:none;
          margin:16px auto 0;
          padding:14px 32px;
          font-size:18px;
          font-weight:700;
          border:none;
          border-radius:10px;
          background:#2e7d32;
          color:white;
          cursor:pointer;">
        🛒 Add Prize to Cart
      </button>

      <p id="cartMsg"
        style="margin-top:10px; font-size:14px; color:#2e7d32; display:none;">
      </p>
    </div>
  `;

  /* ----------------------------
     Canvas Setup (Retina Sharp)
  ----------------------------- */
  const canvas = document.getElementById("wheelCanvas");
  const ctx = canvas.getContext("2d");

  const dpr = window.devicePixelRatio || 1;
  const size = 360;

  canvas.style.width = size + "px";
  canvas.style.height = size + "px";

  canvas.width = size * dpr;
  canvas.height = size * dpr;

  ctx.scale(dpr, dpr);

  const center = size / 2;
  const radius = center - 12;

  /* ----------------------------
     Wheel Items & Weights
     Higher weight = higher chance of landing
  ----------------------------- */
  const items = [
    { label: "Stress Ball ⚾",  weight: 30, variantId: "52529689493783" },
    { label: "Pop Socket 📱",   weight: 25, variantId: "52529693851927" },
    { label: "Koozie 🍺",       weight: 20, variantId: "52529702306071" },
    { label: "Tote Bag 👜",     weight: 12, variantId: "52529714790679" },
    { label: "Hat 🧢",          weight: 8,  variantId: "52529717412119" }
  ];

  const colors = [
    "#f94144",
    "#f3722c",
    "#f9c74f",
    "#43aa8b",
    "#577590"
  ];

  const totalSlices = items.length;
  const slice = (2 * Math.PI) / totalSlices;
  let currentRotation = 0;

  /* ----------------------------
     Weighted Random Selection
  ----------------------------- */
  function getWeightedIndex() {
    const totalWeight = items.reduce((sum, item) => sum + item.weight, 0);
    let rand = Math.random() * totalWeight;

    for (let i = 0; i < items.length; i++) {
      rand -= items[i].weight;
      if (rand <= 0) return i;
    }
    return items.length - 1;
  }

  /* ----------------------------
     Draw Wheel Function
  ----------------------------- */
  function drawWheel(rotation = 0) {

    ctx.clearRect(0, 0, size, size);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    items.forEach((item, i) => {

      const start = i * slice + rotation;
      const end = start + slice;

      /* Slice */
      ctx.beginPath();
      ctx.moveTo(center, center);
      ctx.arc(center, center, radius, start, end);
      ctx.fillStyle = colors[i];
      ctx.fill();

      /* Text */
      ctx.save();
      ctx.translate(center, center);
      ctx.rotate(start + slice / 2);

      ctx.fillStyle = "white";
      ctx.font = "600 14px Arial";
      ctx.textAlign = "center";

      ctx.fillText(item.label, radius - 65, 6);

      ctx.restore();
    });

    /* Outer Border Ring */
    ctx.beginPath();
    ctx.arc(center, center, radius, 0, 2 * Math.PI);
    ctx.lineWidth = 5;
    ctx.strokeStyle = "#ffffff";
    ctx.stroke();
  }

  drawWheel();

  /* ----------------------------
     Spin Logic (One Spin Only)
  ----------------------------- */
  const spinBtn = document.getElementById("spinBtn");
  const resultText = document.getElementById("result");
  const addToCartBtn = document.getElementById("addToCartBtn");
  const cartMsg = document.getElementById("cartMsg");
  const emailGate = document.getElementById("emailGate");
  const emailInput = document.getElementById("emailInput");
  const subscribeBtn = document.getElementById("subscribeBtn");
  const emailError = document.getElementById("emailError");

  /* ----------------------------
     Klaviyo Client-Side Subscribe
  ----------------------------- */
  const KLAVIYO_COMPANY_ID = "UxYwhK";
  const KLAVIYO_LIST_IDS = [
    "UzyaZc",  /* Prize Wheel */
    "VuQvKF"   /* Shopify Segment - Email subscribers */
  ];

  function subscribeToKlaviyo(email) {
    var requests = KLAVIYO_LIST_IDS.map(function (listId) {
      return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY_ID, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-10-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Spin the Wheel",
              profile: {
                data: {
                  type: "profile",
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              list: {
                data: { type: "list", id: listId }
              }
            }
          }
        })
      });
    });

    return Promise.all(requests);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  subscribeBtn.addEventListener("click", function () {
    var email = emailInput.value.trim();

    emailError.style.display = "none";

    if (!email || !isValidEmail(email)) {
      emailError.style.display = "block";
      emailError.innerHTML = "Please enter a valid email address.";
      return;
    }

    subscribeBtn.disabled = true;
    subscribeBtn.innerText = "Subscribing...";

    subscribeToKlaviyo(email)
      .then(function () {
        /* Success — hide email gate, show spin button */
        emailGate.style.display = "none";
        spinBtn.style.display = "inline-block";
        localStorage.setItem("wheelEmail", email);
      })
      .catch(function () {
        emailError.style.display = "block";
        emailError.innerHTML = "Something went wrong — please try again.";
        subscribeBtn.disabled = false;
        subscribeBtn.innerText = "SUBSCRIBE & SPIN";
      });
  });

  /* Allow pressing Enter in the email field */
  emailInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") subscribeBtn.click();
  });

  /* ----------------------------
     Shopify Add-to-Cart via AJAX
  ----------------------------- */
  function addToCart(variantId) {
    addToCartBtn.disabled = true;
    addToCartBtn.innerText = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (res) {
      if (!res.ok) throw new Error("Cart error");
      return res.json();
    })
    .then(function () {
      addToCartBtn.style.display = "none";
      cartMsg.style.display = "block";
      cartMsg.innerHTML = "✅ Prize added to your cart!";
      localStorage.setItem("wheelAddedToCart", "true");
    })
    .catch(function () {
      addToCartBtn.disabled = false;
      addToCartBtn.innerText = "🛒 Add Prize to Cart";
      cartMsg.style.display = "block";
      cartMsg.style.color = "#c62828";
      cartMsg.innerHTML = "Something went wrong — please try again.";
    });
  }

  /* Check if user already spun */
  const previousWin = localStorage.getItem("wheelPrize");
  const previousVariant = localStorage.getItem("wheelVariantId");
  const alreadyAdded = localStorage.getItem("wheelAddedToCart");

  if (previousWin) {
    emailGate.style.display = "none";
    spinBtn.style.display = "inline-block";
    spinBtn.disabled = true;
    spinBtn.innerText = "ALREADY SPUN";
    resultText.innerHTML =
      "🎉 You already won:<br><br><strong>" + previousWin + "</strong>";

    /* Show Add to Cart if they haven't added it yet */
    if (previousVariant && alreadyAdded !== "true") {
      addToCartBtn.style.display = "inline-block";
      addToCartBtn.addEventListener("click", function () {
        addToCart(previousVariant);
      });
    } else if (alreadyAdded === "true") {
      cartMsg.style.display = "block";
      cartMsg.innerHTML = "✅ Prize already in your cart!";
    }
  }

  spinBtn.addEventListener("click", function () {

    spinBtn.disabled = true;

    /* Pick winner using weighted random */
    const targetIndex = getWeightedIndex();

    /* Random full spins for visual drama */
    const randomSpins = Math.floor(Math.random() * 3) + 6;

    /* Small random offset within the winning slice so it doesn't
       always land dead-centre (looks more natural) */
    const randomOffset = (Math.random() - 0.5) * (slice * 0.6);

    /* Calculate final rotation so the pointer (top, 3π/2) lands
       on the chosen slice */
    const finalRotation =
      (randomSpins * 2 * Math.PI) +
      ((3 * Math.PI / 2) - (targetIndex * slice) - slice / 2) +
      randomOffset;

    const startRotation = currentRotation;
    const duration = 4200;
    const startTime = performance.now();

    function animate(time) {

      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);

      /* Smooth ease-out */
      const easeOut = 1 - Math.pow(1 - progress, 3);

      currentRotation =
        startRotation + easeOut * (finalRotation - startRotation);

      drawWheel(currentRotation);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {

        const prizeName = items[targetIndex].label;
        const prizeVariant = items[targetIndex].variantId;

        resultText.innerHTML =
          "🎉 You won:<br><br><strong>" + prizeName + "</strong>";

        localStorage.setItem("wheelPrize", prizeName);
        localStorage.setItem("wheelVariantId", prizeVariant);

        /* Show Add to Cart button */
        addToCartBtn.style.display = "inline-block";
        addToCartBtn.addEventListener("click", function () {
          addToCart(prizeVariant);
        });
      }
    }

    requestAnimationFrame(animate);
  });

});